import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardPlugin from './dashboard-plugin'
import axios from 'axios'
import VuePaginate from 'vuejs-paginate'
import VueSweetalert2 from 'vue-sweetalert2';
import vmodal from 'vue-js-modal'
// Plugins
import App from './App.vue'
import VueCollapse from "vue2-collapse/src";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import "sweetalert2/dist/sweetalert2.min.css"
// router setup
import routes from './routes/routes'
import { http } from './services/HttpService'
import ImageUploader from 'vue-image-upload-resize'
import vueDebounce from 'vue-debounce'

import EventService from "@/services/EventService";

import JsonCSV from 'vue-json-csv'
const VueInputMask = require('vue-inputmask').default
import money from 'v-money'

// plugin setup
Vue.component('paginate', VuePaginate)
Vue.use(VueCollapse);
Vue.use(ImageUploader);
Vue.use(vueDebounce)
Vue.use(VueSweetalert2);
Vue.use(vmodal)
Vue.use(VueInputMask)
Vue.use(VueRouter)
Vue.use(DashboardPlugin)
Vue.use(Loading);
Vue.use(require('vue-moment'));
Vue.component('downloadCsv', JsonCSV)

// register directive v-money and component <money>
Vue.use(money, {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  suffix: '',
  precision: 2,
  masked: false
})

//==================================================================================
// Miscellaneous
//==================================================================================
Vue.prototype.$filters = Vue.options.filters

Vue.filter('reverse', function(value) {
  // slice to make a copy of array, then reverse the copy
  return value.slice().reverse();
});

Vue.filter('currencyBrl', function (value, args) {
  if (value === undefined || value === '' || value === null) {
      return;
  }

  // Bug Fix no toFixed
  value = parseFloat(value);
  var currency_format = '';
  if (args == true || args == 'true') {
      currency_format = 'R$ ';
  }
  return currency_format + value.toFixed(2).replace(".", ",").replace(/(\d)(?=(\d{3})+\,)/g, '$1.');
})

http.interceptors.response.use(undefined, function (error) {
  if(error.response.status === 401) {
     localStorage.clear()
     Object.assign(http.defaults, {headers: {}})
     router.replace('/login');
  }
  throw(error)
})



if(localStorage.getItem("token_admin")) {
  try {
    let user = JSON.parse(localStorage.getItem('user_admin'))
    window.accessLevel = user.access_level
  } catch(err) {

  }
}

var baseDir = "/";

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  mode: 'history',
  base: baseDir,
});

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
    ? to.meta.middleware
    : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to,
    };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

try {
  Vue.prototype.$eventService = new EventService()
} catch(e) {
  console.error("Error on EventService")
  console.error(e)
}

// Register a global custom directive called `v-focus`
Vue.directive('app-event', {
  isLiteral: true,
  // When the bound element is inserted into the DOM...
  bind: function (el, value) {
    el.addEventListener('click', function(event) {
      if(value && value.value) {
        Vue.prototype.$eventService.track(value.value)
      }

      event.stopPropagation()
    })
  }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
});

/* We import element-ui variables at the end so they can override the default element-ui colors */
import './assets/sass/element_variables.scss'
